import {
  DetailedHTMLProps,
  FC,
  forwardRef,
  InputHTMLAttributes,
  useRef,
} from 'react'
import mergeRefs from 'react-merge-refs'
import s from './CheckboxV2.module.scss'
type CheckboxV2Props = {} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

const CheckboxV2: FC<CheckboxV2Props> = forwardRef(
  ({ children, ...props }, ref) => {
    const localRef = useRef<HTMLInputElement>(null)
    return (
      <label className={s.root}>
        <input type="checkbox" ref={mergeRefs([localRef, ref])} {...props} />
        {children} {props.required && '*'}
      </label>
    )
  },
)

CheckboxV2.displayName = 'CheckboxV2'
export default CheckboxV2
